// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".6c85daf387051c51f1c251092df42a620bed8abf.chunk.js";
};